var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuobi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13556_12423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9088 20.6121C28.9088 16.5944 26.972 13.1331 25.4886 11.9999C25.4886 11.9999 25.3856 11.9381 25.3856 12.1029C25.262 19.8704 21.3267 21.9925 19.1428 24.8152C14.1361 31.3671 18.7925 38.537 23.5313 39.8557C26.1891 40.5974 22.9132 38.537 22.5011 34.2103C22.0066 28.9565 28.9088 24.9594 28.9088 20.6121Z",
    fill: "#282E5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5047 23.2701C31.4841 23.2495 31.4429 23.2495 31.4017 23.2701C31.4017 23.2701 31.4017 23.2701 31.3811 23.2907C31.2987 24.2591 30.2273 26.3606 28.8881 28.2767C24.3348 34.7874 26.9308 37.9191 28.3936 39.6086C29.2384 40.5975 28.3936 39.6086 30.5158 38.599C30.6806 38.5166 34.6364 36.4151 35.0691 31.6557C35.5018 27.0199 32.5555 24.1148 31.5047 23.2701Z",
    fill: "#059BDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13556_12423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.131,
    height: 28,
    fill: "white",
    transform: "translate(17 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobi);
export default __webpack_public_path__ + "static/media/Huobi.9c3d6fcd5077f6641cfb858aefe4e151.svg";
export { ForwardRef as ReactComponent };